import { Box } from '@zillow/constellation-10';
import React from 'react';

import AuthorCard from './AuthorCard';
import type { AuthorSidebarProps } from './AuthorPage.types';

/**
 * Sidebar for the author page, displaying the author card on large screens.
 *
 * @param sidebarTop - The CSS top value for the sticky sidebar (e.g., 'layout.looser', '80px'). Defaults to 'layout.looser'.
 */
const AuthorSidebar: React.FC<AuthorSidebarProps> = ({
    author,
    // v8 '$spacing.xl' (48px) → v10 layout.looser (48px).
    sidebarTop = 'layout.looser',
}) => (
    <Box
        data-testid="author-sidebar"
        css={{
            display: 'none',
            lg: {
                display: 'block',
                width: '210px',
                flexShrink: 0,
                position: 'sticky',
                marginBottom: 'looser',
                // sidebarTop is a runtime prop, so Panda's static extractor cannot
                // see its value at build time. It picks up the 'layout.looser'
                // default below from the destructuring, but NOT the value callers
                // actually pass: buildPrimaryAuthorPage sends
                // `${STICKY_SIDEBAR_TOP_PX}px` (101px, computed inside zrs-cms).
                // Both values are safelisted in panda.config.ts staticCss — without
                // that, the class is emitted with no rule behind it and the sticky
                // sidebar silently falls back to `top: auto`, which never pins.
                // If STICKY_SIDEBAR_TOP_PX changes in zrs-cms, update the safelist.
                top: sidebarTop,
                alignSelf: 'flex-start',
                marginTop: '-359px', // Only sidebar overlaps header
            },
            xl: {
                width: '300px',
            },
        }}
    >
        <AuthorCard author={author} />
    </Box>
);

export default AuthorSidebar;
